import classNames from 'classnames'

import Image from '../ui/Image/Image'
import HtmlContent from '../ui/HtmlContent/HtmlContent'
import Markdown from '../Markdown/Markdown'
import { getImageUrl } from '../../utils'
import styles from './BenefitCard.module.scss'

function BenefitCard({ title, description, image, markdownClass }) {
  return (
    <div className={classNames(styles.cardContainer)}>
      <div className={styles.flipCardInner}>
        <div className={styles.flipCardFront}>
          <div className={classNames(styles.topContainer)}>
            <div className={classNames(styles.title)}>{title}</div>
            <HtmlContent
              contentClass={classNames(styles.description)}
              content={description}
            />
          </div>
          <Image
            src={getImageUrl(image)}
            alt={image?.alternativeText}
            className={classNames(styles.image)}
          />
        </div>
        <div className={styles.flipCardBack}>
          <div className={classNames(styles.topContainer)}>
            <div className={classNames(styles.title)}>{title}</div>
            <Markdown
              className={classNames(styles.description, markdownClass)}
              content={description}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BenefitCard
